package com.patronat.top.ui.organisms.venue

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.inputs.InputState
import com.patronat.top.ui.models.OwnerInfoData
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppInputMode
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary100
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.VenueInputLabelText
import com.patronat.top.ui.theme.VenueSectionTitleText
import com.patronat.top.ui.theme.White

@Composable
fun OwnerInfoSection(
    data: OwnerInfoData,
    onDataChange: (OwnerInfoData) -> Unit,
    modifier: Modifier = Modifier,
    title: String = "Власник",
    leadingIcon: Painter? = null,
    readOnly: Boolean = true,
    firstNameLabel: String = "Ім'я",
    lastNameLabel: String = "Прізвище",
    phoneLabel: String = "Номер телефону",
    emailLabel: String = "Електронна пошта"
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(White, RoundedCornerShape(12.dp))
            .border(1.dp, MineShaft100, RoundedCornerShape(12.dp))
            .padding(16.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (leadingIcon != null) {
                Box(
                    modifier = Modifier
                        .size(36.dp)
                        .background(Primary100, RoundedCornerShape(8.dp)),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = leadingIcon,
                        contentDescription = null,
                        modifier = Modifier.size(18.dp)
                    )
                }
                Spacer(modifier = Modifier.width(8.dp))
            }

            Text(
                text = title,
                style = VenueSectionTitleText,
                color = MineShaft950
            )
        }

        Spacer(modifier = Modifier.height(18.dp))

        Column {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                AppInput(
                    label = firstNameLabel,
                    labelTextStyle = VenueInputLabelText,
                    value = data.firstName,
                    onValueChange = { if (!readOnly) onDataChange(data.copy(firstName = it)) },
                    leadingIcon = AppIcons.Profile,
                    readOnly = readOnly,
                    forceState = resolveReadOnlyState(readOnly, data.firstName),
                    modifier = Modifier.weight(1f)
                )

                AppInput(
                    label = lastNameLabel,
                    labelTextStyle = VenueInputLabelText,
                    value = data.lastName,
                    onValueChange = { if (!readOnly) onDataChange(data.copy(lastName = it)) },
                    leadingIcon = AppIcons.Profile,
                    readOnly = readOnly,
                    forceState = resolveReadOnlyState(readOnly, data.lastName),
                    modifier = Modifier.weight(1f)
                )
            }

            Spacer(modifier = Modifier.height(16.dp))

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                AppInput(
                    label = phoneLabel,
                    labelTextStyle = VenueInputLabelText,
                    value = data.phone,
                    onValueChange = { if (!readOnly) onDataChange(data.copy(phone = it)) },
                    readOnly = readOnly,
                    forceState = resolveReadOnlyState(readOnly, data.phone),
                    inputMode = AppInputMode.Phone,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Phone),
                    modifier = Modifier.weight(1f)
                )

                AppInput(
                    label = emailLabel,
                    labelTextStyle = VenueInputLabelText,
                    value = data.email,
                    onValueChange = { if (!readOnly) onDataChange(data.copy(email = it)) },
                    leadingIcon = AppIcons.Email,
                    readOnly = readOnly,
                    forceState = resolveReadOnlyState(readOnly, data.email),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Email),
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}

private fun resolveReadOnlyState(readOnly: Boolean, value: String): InputState? {
    return if (readOnly) {
        if (value.isBlank()) InputState.Default else InputState.Filled
    } else {
        null
    }
}
